import React, { Fragment } from 'react';

const CompanyCreateVideoPost = () => {
  return (
    <Fragment>
      <form method="post" encType="multipart/formData">
        <div className="create-post-avi-text">
          <div className="create-post-avi-container">
            <div className="company-create-post-avi"></div>
          </div>
          <div className="create-post-text-container">
            <textarea
              className="create-post-media-text"
              name="postmediatext"
              placeholder="Add caption here..."
            ></textarea>
          </div>
        </div>
        <div className="upload-container">
          <label htmlFor="profilephotopost" className="setup-image-container">
            <div className="create-post-icons-alt blue">
              <i className="fas fa-plus fa-lg blue"></i>
              <i className="fas fa-film fa-4x mx-5 blue"></i>
            </div>
          </label>
          <input
            type="file"
            name="profilephotopost"
            id="profilephotopost"
            className="file-upload"
          />
        </div>
        <div className="create-post-button-container">
          <button type="submit" className="create-post-button background-blue">
            <i className="far fa-edit mx-5"></i>Create Post
          </button>
        </div>
      </form>
    </Fragment>
  );
};

export default CompanyCreateVideoPost;
